"use client";

export function AuthWaves() {
    return (
        <>
            {/* Animated gradient orbs */}
            <div
                className="absolute rounded-full pointer-events-none"
                style={{
                    width: '60%',
                    height: '60%',
                    top: '-15%',
                    left: '-10%',
                    background: 'radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%)',
                    animation: 'float1 8s ease-in-out infinite',
                }}
            />
            <div
                className="absolute rounded-full pointer-events-none"
                style={{
                    width: '50%',
                    height: '50%',
                    bottom: '-10%',
                    right: '-10%',
                    background: 'radial-gradient(circle, rgba(99,102,241,0.12) 0%, transparent 70%)',
                    animation: 'float2 10s ease-in-out infinite',
                }}
            />
            <div
                className="absolute rounded-full pointer-events-none"
                style={{
                    width: '35%',
                    height: '35%',
                    top: '40%',
                    right: '5%',
                    background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)',
                    animation: 'float3 12s ease-in-out infinite',
                }}
            />

            {/* SVG Animated Waves */}
            <svg
                className="absolute bottom-0 left-0 w-full pointer-events-none"
                style={{ height: '45%', minHeight: '250px' }}
                viewBox="0 0 1440 400"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Wave 1 - back, slowest */}
                <path
                    fill="rgba(59,130,246,0.06)"
                    d="M0,280 C180,220 360,340 540,280 C720,220 900,340 1080,280 C1260,220 1440,300 1440,300 L1440,400 L0,400 Z"
                >
                    <animate
                        attributeName="d"
                        dur="8s"
                        repeatCount="indefinite"
                        values="
                            M0,280 C180,220 360,340 540,280 C720,220 900,340 1080,280 C1260,220 1440,300 1440,300 L1440,400 L0,400 Z;
                            M0,300 C180,340 360,220 540,300 C720,340 900,220 1080,300 C1260,340 1440,280 1440,280 L1440,400 L0,400 Z;
                            M0,280 C180,220 360,340 540,280 C720,220 900,340 1080,280 C1260,220 1440,300 1440,300 L1440,400 L0,400 Z
                        "
                    />
                </path>

                {/* Wave 2 - middle */}
                <path
                    fill="rgba(59,130,246,0.08)"
                    d="M0,300 C240,260 480,350 720,300 C960,250 1200,340 1440,310 L1440,400 L0,400 Z"
                >
                    <animate
                        attributeName="d"
                        dur="6s"
                        repeatCount="indefinite"
                        values="
                            M0,300 C240,260 480,350 720,300 C960,250 1200,340 1440,310 L1440,400 L0,400 Z;
                            M0,320 C240,350 480,260 720,320 C960,350 1200,260 1440,300 L1440,400 L0,400 Z;
                            M0,300 C240,260 480,350 720,300 C960,250 1200,340 1440,310 L1440,400 L0,400 Z
                        "
                    />
                </path>

                {/* Wave 3 - front, fastest */}
                <path
                    fill="rgba(59,130,246,0.05)"
                    d="M0,340 C160,310 320,370 480,340 C640,310 800,370 960,340 C1120,310 1280,360 1440,340 L1440,400 L0,400 Z"
                >
                    <animate
                        attributeName="d"
                        dur="4s"
                        repeatCount="indefinite"
                        values="
                            M0,340 C160,310 320,370 480,340 C640,310 800,370 960,340 C1120,310 1280,360 1440,340 L1440,400 L0,400 Z;
                            M0,350 C160,370 320,310 480,350 C640,370 800,310 960,350 C1120,370 1280,320 1440,350 L1440,400 L0,400 Z;
                            M0,340 C160,310 320,370 480,340 C640,310 800,370 960,340 C1120,310 1280,360 1440,340 L1440,400 L0,400 Z
                        "
                    />
                </path>
            </svg>

            {/* Top wave - subtle */}
            <svg
                className="absolute top-0 left-0 w-full pointer-events-none rotate-180"
                style={{ height: '25%', minHeight: '120px' }}
                viewBox="0 0 1440 200"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill="rgba(59,130,246,0.04)"
                    d="M0,120 C360,80 720,160 1080,120 C1260,100 1440,140 1440,140 L1440,200 L0,200 Z"
                >
                    <animate
                        attributeName="d"
                        dur="10s"
                        repeatCount="indefinite"
                        values="
                            M0,120 C360,80 720,160 1080,120 C1260,100 1440,140 1440,140 L1440,200 L0,200 Z;
                            M0,140 C360,160 720,80 1080,140 C1260,150 1440,110 1440,110 L1440,200 L0,200 Z;
                            M0,120 C360,80 720,160 1080,120 C1260,100 1440,140 1440,140 L1440,200 L0,200 Z
                        "
                    />
                </path>
            </svg>

            {/* Floating particles */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute rounded-full"
                        style={{
                            width: `${4 + i * 2}px`,
                            height: `${4 + i * 2}px`,
                            background: `rgba(59,130,246,${0.15 + i * 0.03})`,
                            left: `${10 + i * 15}%`,
                            top: `${20 + (i % 3) * 25}%`,
                            animation: `particle${i} ${6 + i * 2}s ease-in-out infinite`,
                        }}
                    />
                ))}
            </div>

            {/* CSS Animations */}
            <style>{`
                @keyframes float1 {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    33% { transform: translate(30px, -20px) scale(1.05); }
                    66% { transform: translate(-20px, 15px) scale(0.95); }
                }
                @keyframes float2 {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    33% { transform: translate(-25px, 20px) scale(1.08); }
                    66% { transform: translate(20px, -25px) scale(0.92); }
                }
                @keyframes float3 {
                    0%, 100% { transform: translate(0, 0); }
                    50% { transform: translate(-30px, -20px); }
                }
                @keyframes particle0 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.4; }
                    50% { transform: translateY(-40px) translateX(10px); opacity: 0.8; }
                }
                @keyframes particle1 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.3; }
                    50% { transform: translateY(-60px) translateX(-15px); opacity: 0.7; }
                }
                @keyframes particle2 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.5; }
                    50% { transform: translateY(-35px) translateX(20px); opacity: 0.9; }
                }
                @keyframes particle3 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.3; }
                    50% { transform: translateY(-50px) translateX(-10px); opacity: 0.6; }
                }
                @keyframes particle4 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.4; }
                    50% { transform: translateY(-45px) translateX(15px); opacity: 0.8; }
                }
                @keyframes particle5 {
                    0%, 100% { transform: translateY(0) translateX(0); opacity: 0.3; }
                    50% { transform: translateY(-55px) translateX(-20px); opacity: 0.7; }
                }
            `}</style>
        </>
    );
}
